import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Main.module.scss";
import StateContext from "../../context/state";
import PathContext from "../../context/path";
import Footer from '../../components/Footer';
import Cover from '../../components/Cover';
import Header from '../../components/Header/Header';
import SpyMenu from '../../components/SpyMenu';
import Collapse from '../../components/Collapse';
import ItemList from '../../components/ItemList';
const Main = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const refCoopBtn = useRef(null);
  const refCoop = useRef(null);
  const { updatePopupOpen, isMobile } = state;
  useEffect(() => {
    const coop = refCoop.current;
    const coopBtn = refCoopBtn.current;
    if (isMobile) return;
    const addHover = () => {
      coop.classList.add(styles.hover);
    }
    const removeHover = () => {
      coop.classList.remove(styles.hover);
    }
    coopBtn.addEventListener('mouseover', addHover);
    coopBtn.addEventListener('mouseout', removeHover);
    return () => {
      coop.classList.remove(styles.hover);
      coopBtn.removeEventListener('mouseover', addHover);
      coopBtn.removeEventListener('mouseout', removeHover);
    }
  }, [isMobile]);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <Header />
        </div>
        <Cover />
        <main className={styles.main}>
          <div className={styles.container}>
            <div className={styles.about}>
              <p>Для эффективной работы важны не только навыки сотрудников, но и коммуникация. Если не привести её к единым стандартам, то будут страдать сроки и точность выполнения задач. Поэтому важно ввести регламенты — как быстро надо отвечать на сообщения, в каком формате писать письма, как правильно запланировать встречу и т.д.</p>
              <p>Но иногда возникает проблема — стандарт коммуникаций есть, а сотрудники его не изучают. Почему так происходит, и как этого избежать — расскажем в статье.</p>
            </div>
            <div className={styles.row}>
              <div className={styles.col}>
                <SpyMenu />
              </div>
              <div className={styles.col}>
                <div className={styles.section} data-scrollspy-trigger='0'>
                  <h2 className={styles.h2}>Почему сотрудники не изучают стандарты</h2>
                  <p>Давайте представим, в каком виде обычно представлены различные правила и стандарты компании. Чаще всего это раздел на сайте с «простыней» текста, где правила указаны списком, а то и вовсе pdf-документ, который нужно скачать. Такой формат очень неудобен, потому что:</p>
                  <div className={styles.list}>
                    <Collapse defaultStateOpen={true}>
                      <>Часто там много текста</>
                      <>Подробное описание регламентов и нюансов может занять <br /> 10–15 страниц. Иногда текст ещё и написан сложным, канцелярским языком — чтобы прочитать и понять его, нужно очень много времени.</>
                    </Collapse>
                    <Collapse>
                      <>Сложно найти нужную информацию</>
                      <>Например, сотруднику нужно узнать, как правильно оформлять рабочие письма. Ему придётся выискивать в «простыне» текста блок, где говорится о письмах, а уже в нем — искать правила оформления.</>
                    </Collapse>
                    <Collapse>
                      <>Пользоваться информацией неудобно</>
                      <>Надо заходить на сайт, искать нужный раздел или скачивать pdf. Все это очень долго.</>
                    </Collapse>
                  </div>
                  <p>В результате сотрудники в лучшем случае читают правила один раз и забывают о них, а в худшем — вовсе игнорируют их. И главное, нельзя оценить, сколько вообще сотрудников знакомятся с документом, и как его усваивают. В итоге компания тратит время на ненужную работу — составление регламентов, которыми потом никто не пользуется. И, конечно, коммуникация от этого страдает по‑прежнему.</p>
                </div>

                <div className={styles.section} data-scrollspy-trigger='1'>
                  <h2 className={styles.h2}>Как организовать удобный стандарт корпоративных коммуникаций</h2>
                  <p>Здесь необходимо учитывать три момента:</p>
                  <div className={styles.list}>
                    <ItemList>
                      Актуальность — чтобы в стандарте были отражены действительно важные для сотрудников моменты. Например, если вы практически не используете в работе созвоны, то не стоит уделять им много внимания.
                    </ItemList>
                    <ItemList>
                      Удобство использования — чтобы информация была структурирована, и в ней можно было легко ориентироваться. В pdf-документе сложно сразу найти нужную информацию, поэтому нужно придумать другой формат.
                    </ItemList>
                    <ItemList>
                      Лёгкость для прочтения — чтобы любой сотрудник мог легко понять и в дальнейшем применять стандарт. Иногда регламенты написаны сложным официальным языком, и через «тернии» канцелярита продираться очень трудно. В итоге, сотрудники так и не понимают, чего от них хотят.
                    </ItemList>
                  </div>
                  <p>Поэтому мы рекомендуем начать с составления техзадания по стандарту коммуникаций — можно использовать эти этапы.</p>
                  <h3 className={styles.h3}>Изучите рабочие задачи сотрудников</h3>
                  <p>Определите, в каких ситуациях сотрудники коммуницируют друг с другом. Например, это может быть переписка внутри команды, передача задач от руководителя подчинённым, общение во время совещаний. Важно составить не общие расплывчатые регламенты, а разобрать конкретные ситуации. </p>
                  <p>Также нужно определить, в каких моментах возникают проблемы, и учесть это при составлении регламентов. Например, у нашего недавнего клиента «Северстали» страдало оформление писем — сотрудники писали их сплошным текстом, допускали ошибки, читать письма было сложно. Поэтому мы отдельно прописали правила оформления текста, чтобы читать и понимать его было проще — это сокращало время на коммуникацию и выполнение задач. <a href="https://digital.infografika.agency/case-severstal/" target="_blank" rel="noopener noreferrer">Кейс «Как из 13 страниц регламентов сделать понятную историю о правилах общения в компании»</a></p>

                  <div className={`${styles.block} ${styles.block_image}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/article-img-1-mobile.webp`} />
                      <img src={`${path}/img/article-img-1.webp`} alt="" />
                    </picture>
                  </div>

                  <h3 className={styles.h3}>Структурируйте информацию по блокам</h3>
                  <p>Важно сгруппировать информацию, не «как принято» в компании, а как действительно удобно сотрудникам. Важно, чтобы работник смог найти нужный регламент за несколько секунд, быстро его изучить и применить.</p>
                  <p>Например, можно структурировать регламент по форматам коммуникации: письма, звонки, встречи и рассылки для сотрудников. Если в каком‑то формате есть несколько направлений, нужно их разделить. Например, встречи могут быть регулярные (планёрки, ежемесячные собрания) и нерегулярные (обсуждение итогов проекта, индивидуальное общение) — для каждой должен быть свой регламент.</p>
                  <p className={styles.spaceup}>Составляя структуру каждого блока, прописывайте:</p>
                  <div className={styles.list}>
                    <ItemList>
                    Базовые требования: сроки ответа на сообщение, канал связи, оформление сообщения.
                    </ItemList>
                    <ItemList>
                    Правила коммуникации: что стоит и не стоит указывать в сообщении.
                    </ItemList>
                    <ItemList>
                    Важные дополнения: необходимость использования корпоративных мессенджеров или пароля для видеоконференций.
                    </ItemList>
                  </div>
                  <h3 className={styles.h3}>Составьте тексты</h3>
                  <p>Придерживайтесь известного правила: краткость — сестра таланта. Возможно, вам кажется, что чем подробнее расписаны правила, тем лучше — но это не так. Длинные пространные тексты сложно воспринимать, поэтому информация должна быть краткой, но ёмкой. </p>
                  <p>Переходите от общего к частному. Например, сначала обозначьте базовые правила коммуникации, а затем перейдите к особенностям каждого формата.</p>
                  <div className={`${styles.block} ${styles.block_image}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/article-img-2-mobile.webp`} />
                      <img src={`${path}/img/article-img-2.webp`} alt="" />
                    </picture>
                  </div>
                  <div className={styles.caption}>У «Северстали» было несколько ключевых принципов в коммуникациях — мы упаковали их в инфографику и разместили в начале разработанного стандарта</div>
                  <p className={styles.spaceup}>Чтобы сократить количество текста и подсветить ключевые моменты, используйте инфографику. А второстепенные детали уносите во второй слой информации — например, попапы или ссылки на другие документы.</p>
                  <div className={`${styles.block} ${styles.block_image} ${styles.block_noborder}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/article-img-3-mobile.webp`} />
                      <img src={`${path}/img/article-img-3.webp`} alt="" />
                    </picture>
                  </div>                  
                  <div className={styles.caption}>Описание нерегулярных встреч довольно объёмное — мы вынесли его в попап, чтобы не загружать страницу информацией</div>
                  
                  <h3 className={styles.h3}>Предложите удобный формат</h3>
                  <p>Как мы уже выяснили, pdf или страница со сплошным текстом на сайте — это неудобно. Там сложно организовать информацию или найти нужный регламент. Отличный вариант для составления стандарта — это лендинг. Он доступен с любого устройства и интерактивен, страницу можно разбить на любое количество блоков, разместить там меню и попапы. И главное — вы сможете следить, насколько эффективно сотрудники изучают материал с помощью подключённой аналитики. </p>
                  <p>И главное — лендинг изучать намного проще и интереснее, чем полотно текста в pdf. А значит, сотрудники будут более вовлечены и с большей вероятностью будут использовать регламенты в работе.</p>
                </div>

                <div className={styles.section} data-scrollspy-trigger='2'>
                  <h2 className={styles.h2}>Как оценить эффективность составленного стандарта</h2>
                  <p>Допустим, вы обратились в агентство и с помощью профессионалов составили лендинг по стандартам коммуникации. Но как понять, окупятся ли ваши затраты, и реально ли сотрудники теперь будут изучать все регламенты?</p>
                  <p className={styles.spaceup}>Есть несколько способов проверить эффективность вашего решения:</p>
                  <div className={styles.list}>

                    <Collapse>
                      <>Метрики</>
                      <>Подключите лендинг к сервису аналитике — например, Яндекс.Метрике — и тогда вы сможете понять, сколько сотрудников действительно пользуются ресурсом. С помощью метрики можно легко посчитать затраты. Например, вы потратили на составление регламентов и разработку лендинга 600 тыс. ₽ — кажется, что это внушительная сумма. Но вы увидели по метрике, что ресурсом за месяц воспользовалось 10 тыс. сотрудников, то это значит, что за каждого сотрудника вы заплатили всего 60 ₽ — это совсем небольшая сумма.</>
                    </Collapse>
                    <Collapse>
                      <>Тестирование</>
                      <>Чтобы понять, как работники усвоили знания, можно провести небольшое тестирование по основным правилам коммуникаций. Тест можно устроить онлайн — например, в Google Формах. Ещё один способ — упражнения с выбором сценария. Например, вы можете дать сотрудникам несколько тестовых заданий: написать письмо, назначить встречу по регламентам, запланировать звонок. Так вы сможете не только проверить знания, но и отметить места, где большинство сотрудников допускает ошибки — и потом доработать регламенты.</>
                    </Collapse>
                    <Collapse>
                      <>Обратная связь</>
                      <>После запуска лендинга можно попросить сотрудников поставить ему оценку — насколько все просто, удобно и понятно. Пусть они выскажут своё мнение: чего им не хватает и что хотелось бы уточнить. Чтобы работники были честнее и не боялись высказать своё мнение, можно сделать опрос анонимным.</>
                    </Collapse>
                    <Collapse>
                      <>Аналитика рабочих процессов</>
                      <>Через некоторое время после введения стандарта (например, через месяц, квартал, полгода) нужно оценить, насколько изменились бизнес-процессы. Если все сделано правильно, то коммуникация должна улучшиться, а процессы — стать быстрее и точнее.</>
                    </Collapse>
                  </div>
                  <p>Стоит отметить, что сделать что‑то «раз и навсегда» практически невозможно. В процессе работы с лендингом у сотрудников могут возникнуть вопросы или предложения — так что вполне возможно, что первоначальный вариант придётся дорабатывать. Но только так вы сможете создать полезный ресурс, который действительно улучшит коммуникацию и процессы в целом. Главное — быть в контакте с сотрудниками, отслеживать обратную связь и, по возможности, оперативно отвечать на вопросы по новым регламентам.</p>
                </div>

                <div className={styles.section} data-scrollspy-trigger='3'>
                  <h2 className={styles.h2}>Резюме</h2>
                  <div className={styles.list}>
                    <ItemList>
                    Диджитал-формат идеален для стандартов корпоративных коммуникаций. Он удобен и позволяет быстро найти нужную информацию. А значит, он будет полноценно решать задачи, для которых задумывался: обеспечить ознакомление всех сотрудников с регламентами коммуникации.
                    </ItemList>
                    <ItemList>
                    Метрики позволяют точно оценить, сколько сотрудников пользовалось созданным лендингом, и увидеть, сколько было потрачено на знакомство каждого сотрудника с регламентами.
                    </ItemList>
                    <ItemList>
                    Чтобы оценить, как сотрудники усвоили материал, можно использовать тестирование — это позволит не только проверить работников, но и выявить сложные места в стандарте.
                    </ItemList>
                    <ItemList>
                    Важно собирать обратную связь от сотрудников, чтобы дорабатывать лендинг и делать его удобнее. Чтобы работники не опасались выставлять оценки, можно сделать их анонимными.
                    </ItemList>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className={styles.cooperate} ref={refCoop}>
            <div className={styles.point}>
              Сотрудничать
            </div>
            <div className={`${styles.cooperate__text} `}>У вас есть похожая задача? Напишите нам! Мы предложим решение и подберем референсы</div>
            <div className={styles.cooperate__btn} ref={refCoopBtn} onClick={() => updatePopupOpen(true)}>Написать</div>
          </div>
          <div className={styles.container}>
            <div className={styles.more}>
              <h2 className={styles.more__title}>
                <span>вам также</span> <span className={styles.more__line}></span> <span>понравится</span>

                <div className={styles.more__icon}>
                  <img src={`${path}/img/more-icon.svg`} alt="" />
                </div>
              </h2>
              <div className={styles.more__text}>За 12 лет работы агентства мы сделали более 350 коммуникационных проектов</div>
              <div className={styles.more__row}>
                <div className={styles.more__col}>
                  <a href='https://www.infografika.agency/blog/kak-pobudit-sotrudnikov-delitsya-svoimi-ideyami-i-sekonomit-na-etom-mnogo-deneg' className={styles.more__card}>
                    <div className={`${styles.more__card_img}`}>
                      <img src={`${path}/img/more-img-1.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={styles.more__card_title}>Как побудить сотрудников делиться своими идеями и сэкономить на этом много денег?</div>
                        <div className={styles.more__card_comp}>HR <span>(Вовлеченность) (Мотивация)</span></div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
                <div className={styles.more__col}>
                  <a href='https://www.infografika.agency/blog/kak-translirovat-cennosti' className={styles.more__card}>
                    <div className={`${styles.more__card_img}`}>
                      <img src={`${path}/img/more-img-2.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={styles.more__card_title}>Как транслировать корпоративные ценности, чтобы сотрудники начали следовать им на практике</div>
                        <div className={styles.more__card_comp}>HR <span>(Миссия) (HR-бренд) (Ценности)</span></div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
                <div className={styles.more__col}>
                  <a href='https://www.infografika.agency/blog/kak-sozdat-welcome-book-kotoryy-sotrudniki-zahotyat-prochitat' className={styles.more__card}>
                    <div className={`${styles.more__card_img}`}>
                      <img src={`${path}/img/more-img-3.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={styles.more__card_title}>Как создать welcome book, который сотрудники захотят прочитать?</div>
                        <div className={styles.more__card_comp}>HR <span> (Адаптация) (Обучение) (HR-бренд)</span></div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );

}

export default Main;
